import classNames from 'classnames';
import { Tag } from 'antd';
import type { TagProps } from 'antd';
import type { themeColourAttributes } from '@app/utils/constants';

export type StyledTagProps = TagProps & {
	color?: keyof typeof themeColourAttributes;
	type?: 'primary' | 'secondary';
};

/**
 * Primary UI component for user interaction
 */
export const StyledTag = ({ color = 'default', type = 'primary', ...props }: StyledTagProps) => {
	const tagClasses = classNames(
		'styled-tag',
		{ [`styled-tag-color-${color}`]: color, [`styled-tag-${type}`]: type },
		props.className
	);
	return <Tag {...props} className={tagClasses} />;
};
